// extracted by mini-css-extract-plugin
export default {"_clear":"ixUDb9ue"};